import { Component, EventEmitter, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ConfigService, MessageService, FormsUtilsService, ButtonLoader } from '../../../../../../core';
import { ConfigEmpresa, createNomeCliente } from '../../../../../configuracoes/app/empresa';
import { ClienteCrudHttpService } from '../../../services';
import { Cliente } from '../../../cliente';
import { ClienteUnidadeNegocioInsert } from '../cliente-unidade-negocio-insert';
import { ClienteUnidadeNegocioHttpService } from '../../services';
import { UnidadeNegocio, UnidadeNegocioCrudHttpService, UnidadeNegocioFilter, unidadeNegocioAtiva } from '../../../../../unidade-negocio';
import { UnidadeNegocioMercado, UnidadeNegocioMercadoFilter, UnidadeNegocioMercadoHttpService } from '../../../../../unidade-negocio/mercado';
import { UnidadeNegocioNaturezaVenda, UnidadeNegocioNaturezaVendaFilter, UnidadeNegocioNaturezaVendaHttpService } from '../../../../../unidade-negocio/natureza-venda';
import { mercadoAtivo } from '../../../../../mercado';
import { naturezaVendaAtiva } from '../../../../../natureza-venda';
import { ItemTipo, itemTipoAtivo, ItemTipoFilter, ItemTipoCrudHttpService } from '../../../../../item-tipo';

@Component({
    selector: 'sgt-cliente-unidade-negocio-insert-modal',
    templateUrl: './cliente-unidade-negocio-insert-modal.component.html',
    styleUrls: ['./cliente-unidade-negocio-insert-modal.component.less']
})
export class ClienteUnidadeNegocioInsertModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;

    @Input() idModal: string;
    elModal: any;
    @Output() afterInsert = new EventEmitter<ClienteUnidadeNegocioInsert>();

    @Input() mercadoRequired = false;
    @Input() naturezaVendaRequired = false;
    @Input() itemTipoRequired = false;

    @ViewChild('form') form: NgForm;
    cliente: Cliente;
    entity: ClienteUnidadeNegocioInsert;

    unidadesNegocio: UnidadeNegocio[] = [];
    mercados: UnidadeNegocioMercado[] = [];
    naturezasVendas: UnidadeNegocioNaturezaVenda[] = [];
    itensTipos: ItemTipo[] = [];

    constructor(private el: ElementRef,
                private configService: ConfigService,
                private formsUtilsService: FormsUtilsService,
                private messageService: MessageService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private clienteUnidadeNegocioHttpService: ClienteUnidadeNegocioHttpService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService,
                private unidadeNegocioMercadoHttpService: UnidadeNegocioMercadoHttpService,
                private unidadeNegocioNaturezaVendaHttpService: UnidadeNegocioNaturezaVendaHttpService,
                private itemTipoCrudHttpService: ItemTipoCrudHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.create();

        this.searchUnidadesNegocio();
        this.searchItensTipos();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal.on('shown.bs.modal', () => {
            jQuery(this.elModal).find('#unidadeNegocioInsert').trigger('focus');
        });
    }

    /** Pesquisas as unidades de negócio cadastradas */
    private searchUnidadesNegocio() {
        const filter = new UnidadeNegocioFilter();
        filter.situacao = unidadeNegocioAtiva.id;
        this.unidadeNegocioCrudHttpService.searchWithFilter(filter)
            .subscribe(
                entities => this.unidadesNegocio = entities,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as Unidades de Negócio', error)
            );
    }

    /** Cria o nome do cliente para exibir no template */
    createNomeCliente(): string {
        if (!this.cliente || !this.cliente.pessoa) {
            return '';
        }

        return createNomeCliente(this.configEmpresa.identificacaoCliente, this.cliente.pessoa.nome, this.cliente.pessoa.nomeFantasia);
    }

    /** Ao selecionar a unidade de negócio */
    onSelectUnidadeNegocio(id: number) {
        this.entity.idUnidadeNegocio = id;
        this.entity.idMercado = null;
        this.entity.idNaturezaVenda = null;
        this.entity.idItemTipo = null;

        // Mercados
        if (this.entity.idUnidadeNegocio) {
            this.searchMercados(this.entity.idUnidadeNegocio);
        } else {
            this.mercados = [];
        }

        // Naturezas de Vendas
        if (this.entity.idUnidadeNegocio) {
            this.searchNaturezasVendas(this.entity.idUnidadeNegocio);
        } else {
            this.naturezasVendas = [];
        }
    }

    /** Pesquisas os mercados vinculados na unidade de negócio */
    private searchMercados(idUnidadeNegocio: number) {
        this.mercados = [];
        const filter = new UnidadeNegocioMercadoFilter();
        filter.situacaoMercado = mercadoAtivo.id;
        this.unidadeNegocioMercadoHttpService.search(idUnidadeNegocio, filter)
            .subscribe(
                mercados => this.mercados = mercados,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os mercados vinculados a unidade de negócio', error)
            );
    }

    /** Pesquisas as naturezas de vendas vinculadas na unidade de negócio */
    private searchNaturezasVendas(idUnidadeNegocio: number) {
        this.naturezasVendas = [];
        const filter = new UnidadeNegocioNaturezaVendaFilter();
        filter.situacaoNaturezaVenda = naturezaVendaAtiva.id;
        this.unidadeNegocioNaturezaVendaHttpService.search(idUnidadeNegocio, filter)
            .subscribe(
                naturezasVendas => this.naturezasVendas = naturezasVendas,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as naturezas de vendas vinculadas a unidade de negócio', error)
            );
    }

    /** Pesquisa os tipos de itens */
    private searchItensTipos() {
        this.itensTipos = [];
        const filter = new ItemTipoFilter();
        filter.situacao = itemTipoAtivo.id;
        this.itemTipoCrudHttpService.searchWithFilter(filter)
            .subscribe(
                itensTipos => this.itensTipos = itensTipos,
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar tipos de produtos', error)
            )
    }

    /** Obtem os dados do cliente */
    private findCliente(idCliente: number) {
        this.clienteCrudHttpService.find(idCliente)
            .subscribe(
                entity => this.cliente = entity,
                (error: ApiError) => {
                    this.cliente = null;
                    this.messageService.error(error.message, 'Erro ao obter o cliente para adicionar a unidade de negócio', error.message)
                }
            );
    }

    private clear() {
        this.cliente = null;
        this.form.resetForm();
    }

    open(idCliente: number) {
        this.findCliente(idCliente);
        this.entity = new ClienteUnidadeNegocioInsert(idCliente);
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.clear();
        this.elModal.modal('hide');
    }

    save() {
        if (this.form.valid) {
            const btnInsertSave = new ButtonLoader('#btnInsertSave');
            btnInsertSave.loading('Adicionando');
            this.clienteUnidadeNegocioHttpService.insert(this.entity)
                .subscribe(
                    () => {
                        this.messageService.success('', 'Unidade de negócio adicionada ao cliente com sucesso');

                        btnInsertSave.reset();
                        this.afterInsert.emit(this.entity);
                        this.close();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao adicionar', error);
                        btnInsertSave.reset();
                    }
                )
        } else {
            this.formsUtilsService.showMsgFormInvalid();
        }
    }
}
